module.exports = __webpack_public_path__ + "img/icon-ticket_number.6e29e504.svg";